import React, { Component } from 'react';
import { Button, ButtonGroup, Container, Table, Form, FormGroup, Input, Label } from 'reactstrap';
import AppNavbar from '../AppNavbar';
import { Link, withRouter } from 'react-router-dom';
import Fuse from 'fuse.js';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

class KeySkillList extends Component {

    constructor(props) {
        super(props);
        this.state = {keySkills: [],
            isLoading: true,
            searchValue: '',
            accessToken: localStorage.getItem("accessToken")
        };
        this.remove = this.remove.bind(this);
        this.confirmDelete = this.confirmDelete.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.tokenExpired = this.tokenExpired.bind(this);
    }

    componentDidMount() {
        this.setState({isLoading: true});

        this.getKeySkills()
    }

    async getKeySkills() {
        await fetch('/key-skill', {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.state.accessToken}`
            })
        })
            .then((response) => {
                if (response.status === 200) {
                    return response.json();
                }
                else if (response.status === 401) {
                    this.tokenExpired();
                }
            })
            .then((data) => {
                this.setState({keySkills: data, isLoading: false});
            })
    }

    confirmDelete = (id, name) => {
        confirmAlert({
            title: 'Confirm to submit',
            message: `Are you sure to delete ${name}?`,
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => this.remove(id)
                },
                {
                    label: 'No',
                    onClick: () => {}
                }
            ]
        })
    };

    tokenExpired = () => {
        confirmAlert({
            title: 'Token expired',
            message: `Please log in again to continue.`,
            buttons: [
                {
                    label: 'Login',
                    onClick: () => this.props.history.push('/')
                }
            ]
        })
    };

    async remove(id) {
        await fetch(`/key-skill/${id}`, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.state.accessToken}`
            },
        }).then((response) => {
            if (response.status === 204) {
                this.setState({isLoading: true})
                this.getKeySkills()
            } else if (response.status === 401) {
                this.tokenExpired();
            }
        });
    }

    handleChange(event) {
        this.setState({searchValue: event.target.value});
    }

    render() {
        const {keySkills, isLoading} = this.state;

        if (isLoading) {
            return <p>Loading...</p>;
        }

        let options = {
            shouldSort: true,
            threshold: 0.6,
            location: 0,
            distance: 100,
            maxPatternLength: 32,
            minMatchCharLength: 1,
            keys: [
                "name"
            ]
        };

        let fuse = new Fuse(keySkills, options);
        let result = this.state.searchValue ? fuse.search(this.state.searchValue) : keySkills;
        result = result ? result : [];

        return (
            <div>
                <AppNavbar/>
                <Container fluid>
                    <div className="float-right">
                        <Button color="success" tag={Link} to="/keySkills/new">Add KeySkill</Button>
                    </div>
                    <br/>
                    <br/>
                    <div className="float-right">
                        <Form>
                            <FormGroup>
                                <Label for="search">Search</Label>
                                <Input type="text" name="search" id="search"
                                       onChange={this.handleChange} autoComplete="search"/>
                            </FormGroup>
                        </Form>
                    </div>
                    <h3>KeySkills</h3>
                    <Table className="mt-4">
                        <thead>
                        <tr>
                            <th width="1fr">Name</th>
                            <th width="1fr">Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                            {result.map(keySkill => {
                                return <tr key={keySkill.id}>
                                    <td>{keySkill.name}</td>
                                    <td>
                                        <ButtonGroup>
                                            <Button size="sm" color="primary" tag={Link} to={"/keySkills/" + keySkill.id}>Edit</Button>
                                            <Button size="sm" color="danger" onClick={() => this.confirmDelete(keySkill.id, keySkill.name)}>Delete</Button>
                                        </ButtonGroup>
                                    </td>
                                </tr>
                            })}
                        </tbody>
                    </Table>
                </Container>
            </div>
        );
    }
}

export default withRouter(KeySkillList);
